import Client from '../client';
import { AxiosResponse } from 'axios';
import BaseService from '../baseService/baseService';

const ParametroFatorMargemVplAlvoService = 
{
    deletarExcelParametroFatorMargemVplAlvo(fileRequest: any)
    {
        return BaseService.conectarEndpoint(fileRequest, 'parametro-fator-margem-vpl-alvo/excel/deletar', 'excelParametroFatorMargemVplAlvoDeletar');
    },
    salvarExcelParametroFatorMargemVplAlvo(fileRequest: any)
    {
        return BaseService.conectarEndpoint(fileRequest, 'parametro-fator-margem-vpl-alvo/excel', 'excelParametroFatorMargemVplAlvo');
    },
    obterExcel(): Promise<void | AxiosResponse<any>> 
    {
        return Client.getBlob('parametro-fator-margem-vpl-alvo/excel');
    },
    enviarParametrosAoEventGrid(): Promise<void | AxiosResponse<any>> 
    {
        return Client.post('parametro-fator-margem-vpl-alvo/eventGrid', {});
    }
}

export default ParametroFatorMargemVplAlvoService;